"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPvr = createPvr;
const events_1 = require("../../../events");
const queries_1 = require("../queries");
function createPvr({ formatNumber }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.pvr);
    if (event === undefined) {
        return { value: "-" };
    }
    return {
        value: formatNumber(event.value),
        timestamp: event.timestamp,
        origin: event.origin
    };
}
